import { HOST_COUNTRY } from 'aster-foundation/core/common/utils/ApiConst';
import { PAGE_NAME, PAGE_TYPE } from "@common/Constants/analytics";
import { IC_FLAG_966, IC_FLAG_971 } from "@common/Assets/images";

export const APP_DATE_FORMAT = 'DD/MM/YY HH:mm';
export const APP_TIMESTAMP_FORMAT = 'DD/MM/YY HH:mm:ss';
export const APP_LOCAL_DATE_FORMAT = 'DD/MM/YY';
export const APP_SERVER_DATE_FORMAT = 'YYYY-MM-DD';
export const APP_LOCAL_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm';
export const APP_LOCAL_DATETIME_FORMAT_S = 'YYYY-MM-DD HH:mm:ss';
export const APP_LOCAL_DATETIME_FORMAT_Z = 'YYYY-MM-DDTHH:mm Z';
export const APP_LOCAL_DATETIME_FORMAT_SA = 'DD MMM, YYYY - h:mmA';
export const APP_LOCAL_DATETIME_FORMAT_SA2 = 'YYYY-MM-DD HH:mm';
export const APP_LOCAL_TIME_FORMAT = 'LT';
export const APP_LOCAL_COMPONENT_DATE_FORMAT = 'Do MMM YY';
export const APP_LOCAL_APPOINTMENT_DATE_FORMAT = 'DD MMM YY';
export const APP_LOCAL_DATE_MONTH_FORMAT = 'DD MMM';
export const APP_WHOLE_NUMBER_FORMAT = '0,0';
export const APP_TWO_DIGITS_AFTER_POINT_NUMBER_FORMAT = '0,0.[00]';
export const APP_LOCAL_DATE_FORMAT_APPOINTMENT = 'DD/MM/YYYY';
export const APP_DATE_FORMAT_COMMA = 'DD MMM, YYYY';
export const APP_DATE_MONTH_COMMA_FORMAT = 'DD MMM, YYYY';
export const APP_DATE_DAY_MONTH_COMMA_FORMAT = 'dddd, DD MMM, YYYY';
export const APP_TIME_FORMAT = 'hh:mm a';
export const APP_MONTH_YEAR_FORMAT = 'MMM , YYYY';
export const APP_MONTH_DAY_YEAR_FORMAT = 'MMM DD, YYYY';
export const APP_24_HOUR_FORMAT = 'HH:mm';
export const APP_12_HOUR_FORMAT = 'h:mm A';
export const GST_TIME_ZONE = '+0400';
export const PAYMENT_ACTION = 'SALE';
export const PAYMENT_CURRENCY = 'AED';
export const PAYMENT_LANGUAGE = 'en';
export const TELECONSULT_ROUTE = '/doctor-consultation';
export const TELECONSULT_PATH = 'doctor-consultation';
export const TELECONSULT_TITLE = 'Consult a Doctor';
export const ONLINE_PHARMACY_ROUTE = '/online-pharmacy';
export const PROMOTION_LEAFTLET_ROUTE = '/promotion-leaflet';
export const KSA_ONLINE_PHARMACY_ROUTE = '/sa-en/online-pharmacy';
export const KSA_AR_ONLINE_PHARMACY_ROUTE = '/sa-ar/online-pharmacy';
export const ONLINE_PHARMACY_PAYMENT_SUCCESS = '/paymentsuccess';
export const HOME = '/';
export const CHECKOUT = '/online-pharmacy/checkout';
export const SPCHECKOUT = '/online-pharmacy/spcheckout';
export const RX_UPLOAD = '/online-pharmacy/rxupload';
export const RX_UPLOAD_HOMECARE = '/home-care/rxupload';
export const MY_CART_ROUTE = '/online-pharmacy/mycart';
export const MOUNJARO_HOME_ROUTE = '/online-pharmacy/freeconsult';
export const ONLINE_PHARMACY_BRAND_ROUTE = 'online-pharmacy/brand/';
export const ONLINE_PHARMACY_CATEGORY_ROUTE = 'online-pharmacy/c/';
export const MY_RECORDS = '/doctor-consultation/records';
export const MY_BOOKING_STATUS = '/doctor-consultation/checkout';
export const MY_APPOINTMENTS = '/doctor-consultation/appointments';
export const POST_CONSULTATION = '/doctor-consultation/appointments/postconsultation';
export const MY_BOOKING_CONFIRMATION = '/doctor-consultation/checkout/detail';
export const MY_BOOKING_DETAIL = '/doctor-consultation/appointments/detail';
export const PACKAGE_CHECKOUT = '/doctor-consultation/packages/checkout';
export const ONLINE_PHARMACY_TITLE = 'Online Pharmacy';
export const OUT_OF_STOCK_ERROR_MESSAGE = 'Cannot update quantity as it is not available in stock';
export const ADD_TO_CART_MESSAGE = 'Item added in cart';
export const UPDATE_CART_MESSAGE = 'Item updated in cart';
export const DELETE_CART_MESSAGE = 'Item deleted from cart';
export const ADD_TO_CART_ERROR_MESSAGE = 'Oops, Something went wrong';
export const PAYMENT_FAIL_ERROR_MESSAGE = 'Payment could not be processed';
export const MERCHANT_IDENTIFIER = 'merchant.com.asterSandboxApplepay';
export const SPECIALITY_URL = 'speciality-list';
export const CLINIC_URL = 'clinic-list';
export const PACKAGE_URL = 'packages';
export const PACKAGE_SERVICE_TYPE = 'Package';
export const PACKAGE_LIST_TYPE = 'Product Carousel';
export const PRODUCTS_DETAILS_PAGE = 'productsDetailsPage';
export const UAE_COUNTRY_CODE = 101;
export const TOAST_AUTOCLOSE = 10000;
export const FIRST_ERX_SCREEN = '1';
export const SECOND_ERX_SCREEN = '2';
export const FINAL_ERX_SCREEN = '3';
export const INVALID_DATE = 'Invalid date';
export const CHECKOUT_PROMOTION_BREAKDOWN_FLAG = 'checkout_promotion_breakdown_flag';
export const CART_PROMOTION_BREAKDOWN_FLAG = 'cart_promotion_breakdown_flag';
export const ORDER_DETAILS_PROMOTION_BREAKDOWN_FLAG = 'order_details_promotion_breakdown_flag';
export const SEO_WEB_FOOTER_CONTENT_FLAG = 'seo_web_footer_content_flag';
export const SEO_WEB_FOOTER_LINK_FLAG = 'seo_web_footer_links_flag';
export const PRODUCT_RATINGS_FLAG = 'pdp_product_ratings_flag';
export const PRODUCT_REVIEW_FLAG = 'pdp_product_review_flag';
export const ORDER_DETAILS_CTA_FLAG = 'orderDetailsCTAflag';
export const PRODUCT_RECOMMENDATION_DATA = 'product_recommendation_data';
export const CART_RECOMMENDATION_DATA = 'cart_recommendation_data';
export const PRODUCT_NOT_FOUND_RECOMMENDATION_DATA = 'product_not_found_recommendation_data';
export const ORDER_CONFIRMATION_RECOMMENDATION_DATA = 'order_confirmation_recommendation_data';
export const PLP_UPSELLING_RECOMMENDATION_DATA = 'plp_upselling_recommendation_data';
export const REDIRECT_TO_CHECKOUT = 'redirect_to_checkout';
export const UPLOAD_PRESCRIPTION_TEXT =
  'Order medicines without hassles. Upload your prescription, enjoy online insurance approval and get medicines delivered to your doorsteps for free.';
export const PRESCRIPTION_MEDICATION_TEXT = "You've already ordered the prescription medications.";
export const UPLOADED_SUCCESSFULLY = 'Document Uploaded Successfully';
export const DELETED_UPLOADED_SUCCESSFULLY = 'Document Deleted Successfully';
export const INVALID_UPLOADED_FILE = 'Please upload proper document';
export const MAX_FILESIZE_UPLOAD_ERROR = 'Maximum upload file size is 10 MB';
export const ERROR_API_UPLOAD_PRESCRIPTION = 'Error on pharmacy cart rx upload documents';
export const TELECONSULT_ZONE = 'teleconsultation';
export const FBT_SECTION_FLAG = 'fbt_section_flag';
export const PDP_UPSELLING_FLAG = 'pdp_upselling';
export const ONLINE_APPTMODE_IGP = 'Online';
export const SHOW_REMOVE_CTA = 'showRemoveCta';
export const ERX_TIMELINE = 'erx_successful_timeline';
export const VIEW_ALL_RESULT = 'pharmacy_viewAll_flag';
export const INS_ZONE = 're_pharmacy_web_locale';
export const PHARMACY_REDIRECT_FLAG = 'pharmacy_redirect_flag';
export const ONLINE_MESSAGE = "Looks like you haven't placed any orders yet.";
export const GENERIC_ERROR_MESSAGE = 'Something went wrong here, please try again later.';
export const INSTORE_MESSAGE =
  'Your in-store orders will be displayed here. We are currently working on retrieving your purchase history. Please check back later.';
export const AUTH_SUCCESS = 'onAuthSuccess';
export const ASTER_ICON_TITLE = 'Aster Dedicated Doctors';
export const SEND_VIEW_ITEM_LIST_EVENT = 'sendViewItemListEvent';
export const SEND_SELECT_ITEM_EVENT = 'sendSelectItemEvent';
export const SEND_CART_EVENT = 'sendCartEvent';
export const SEND_VIEW_ITEM_EVENT = 'sendViewItemEvent';
export const UAE_CODE = 'AE';
export const GENERIC_COUPON_MESSAGE = "The coupon code isn't valid. Verify the code and try again.";
export const ONLINE_ACCOUNT = "Do you have an online account with myAster?";
export const REDIRECT_URI = 'redirectUri';
export const REDIRECT_PATH = 'redirectPath';
export const EMIRATES_ID = 'emiratesID';
export const EMIRATESEXPDATE = 'emiratesExpDate';
export const PASSPORTEXPDATE = 'passportExpDate';
export const UNDEFINED = 'undefined';
export const CHOOSE_LOCATION = 'Choose Location';
export const ADD_NEW_ADDRESS = 'Add New Address';
export const PROMOTION_LEAFTLET = 'Promotional LeafLet';
export const NON_RETURNABLE_ICON = 'Non-returnable Item';
export const PERSONAL_CARE = 'Personal Care Essentials';
export const PROMOTION_LEAFTLET_TEXT = 'PromotionLeafLet';
export const TEMPORARILY_OUT_OF_STOCK = 'Temporarily Out of Stock';
export const TRUE = 'true';
export const FALSE = 'false';
export const LIGHT = 'Light';
export const DARK = 'Dark';
export const BRANDS_PHARMACY_TITLE = 'Brands';
export const BRAND_LISTING_ROUTE = '/online-pharmacy/brandlisting';
export const KSA_REQ_URL = 'sa-en';
export const KSA_AR_REQ_URL = 'sa-ar';
export const ONLINE_PHARMACY_REQ_URL = 'online-pharmacy';
export const KSA_REGION_CODE = 'sa';
export const UAE_REGION_CODE = 'uae';
export const KSA_EN_SUBDOMAIN = '/sa-en';
export const UAE_EN_SUBDOMAIN = '/uae-en';
export const UAE_AR_SUBDOMAIN = '/uae-ar';
export const KSA_AR_SUBDOMAIN = '/sa-ar';

export const REGION_LANG_TYPES = {
  UAE_EN: 'uae-en',
  KSA_EN: 'sa-en',
  UAE_AR: 'uae-ar',
  KSA_AR: 'sa-ar',
}
export const HOMECARE = 'homecare'
export const HOMECARE_SEARCH_RESULT = 'homecare search result'

export const numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

export const UAE_PASS = {
  LOGIN: "Login with UAE PASS",
  FIRST_NOTE: "Your UAE PASS account will be linked to your existing myAster profile",
  SECOND_NOTE: "Your myAster profile will be established based on the UAE PASS account.",
  NOTE: "This is a one time process, your future login’s through UAE PASS will be seamless.",
};

export const SOP1 = "SOP1";
export const SOP2 = "SOP2";
export const SOP3 = "SOP3";

export const SOP1_TEXT_BASIC_REGISTRATION = "Please enter your below details to complete registration";
export const SOP2_TEXT_BASIC_REGISTRATION = "Please enter your date of birth to complete basic registration";
export const SOP3_TEXT_BASIC_REGISTRATION = "Please enter your date and month of birth to complete basic registration";

export const SOP1_COMPLETE_PROFILE_TEXT = "To complete your profile, please enter your Emirates ID and expiry date";
export const SOP2_COMPLETE_PROFILE_TEXT = "To complete your profile, please enter your Emirates ID expiry date";

export const REGISTRATION_UAE_PASS = "Registration";
export const COMPLETE_PROFILE_UAE_PASS = "Complete Profile";

export const INSTORE_DOMAIN = 'instore';
export const INSTORE = 'INSTORE';
export const GET_CART_INFOS_V1 = "getCartInfosV1";
export const GET_CART_INFOS = "getCartInfos";

export const productReviewsErrorMessage = {
  title: 'Please add review title',
  description: 'Please write a review',
};

export const ORDER_STATUS = {
  FAIL: 'FAILED',
  CAPTURED: 'CAPTURED',
};

export const APPOINTMENT_TYPES = {
  INSTANTGP: 'instantGP',
};

export const APPOINTMENT_TYPE_VIDEO = 'VIDEO';
export const SELECT_INSURANCE_PROVIDER = 'Select Insurance Provider';
export const APPOINTMENT_LISTING_SCREEN = 'Appointment Listing Screen';

export const PAYMENT_METHODS_VALUE = {
  payViaNewCard: 'Pay with New Card',
  payViaSavedCard: 'Pay via Saved Card',
  payCreditCard: 'Pay via Credit/Debit Card',
  applePay: 'Pay',
  cod: 'Cash on Delivery',
};

export const MODULE = {
  AE: "AE",
  HC: "HomeCare",
  AT: "AT",
  ASCO: "ASCO",
};

export const ONE_ASTER_CATEGORY_HOME = {
  PHARMACY: 'Epharmacy Home',
  DOCTOR: 'Tele Consult Home',
  CORE: 'Aster Core Home',
  HOMECARE: 'Homecare',
};
export const SCREEN_TYPE = {
  PHARMACY: 'Epharmacy',
  DOCTOR: 'Teleconsult',
  CORE: 'Core',
  HOMECARE: 'Homecare',
};

export const CMS_BUSINESS_UNIT = {
  PHARMACY: 'Pharmacy',
  DOCTOR: 'Teleconsultation',
  CORE: 'Aster Core',
  HOMECARE: 'Homecare',
};

export const MODULE_TYPE = {
  PHARMACY: 'EPHARMACY',
  CHECKOUT: 'CHECKOUT',
  CART: 'CART'
};

export const COUPON_PROMOTION_TYPE = {
  BANK: 'BANK_COUPON',
  COUPON: 'COUPON',
  BANK_PROMO: 'BANK_PROMO',
  REFERRAL: 'REFERRAL',
  OTHERS: 'OTHER'
};

export const DYNAMIC_DASHBOARD_PARAMETER = {
  CORE: 'ASCO/details',
  DOCTOR: 'TELECONSULTATION/details',
  PHARMACY: 'PHARMA/details',
  HOMECARE: 'AHC/details',
  DEALS: 'deals/details',
};

export const ONE_ASTER_CATEGORY = {
  PHARMACY: 'epharmacy',
  DOCTOR: 'Doctor Consult',
  CORE: 'asco',
  HOMECARE: 'Homecare',
};
export const ASTER_PURCHASE_TYPES = {
  PHARMACY: 'Epharmacy',
  DOCTOR: 'Doctor consult',
};
export const ASTER_PRODUCT_TYPES = {
  PHARMACY: 'Epharmacy',
  DOCTOR: 'Doctor consult',
  HOMECARE: 'Homecare',
};
export const ASTER_PRODUCT_AVAILABILITY = {
  IN_STOCK: 'In Stock',
  OUT_OF_STOCK: 'Out Of Stock',
};

export const PAYMENT_MODE = {
  COD: 'cashondelivery',
  ONLINE: 'online_payment',
};

export const PAYMENT_OPTIONS = {
  CASH: 'CASH',
  CASH_LOYALTY: 'CASH_LOYALTY',
  CARD: 'CARD',
  CARD_LOYALTY: 'CARD_LOYALTY',
  LOYALTY: 'LOYALTY',
  FREE: 'FREE',
  CASH_ON_DELIVERY: 'CASH_ON_DELIVERY',
  PAY_VIA_CARDS: 'PAY_VIA_CARDS',
  SAVED_CARD: 'SAVED_CARD',
  NEW_CARD: 'NEW_CARD',
  PAY_AT_COUNTER: 'PAY_AT_COUNTER',
  COD: 'COD',
};

export const PAYMENT_METHODS = {
  CASH: 'CASH',
  CASH_LOYALTY: 'CASH_LOYALTY',
  CARD: 'CARD',
  CARD_LOYALTY: 'CARD_LOYALTY',
  LOYALTY: 'LOYALTY',
  FREE: 'FREE',
  CASH_ON_DELIVERY: 'Cash on Delivery',
  PAY_VIA_CARDS: 'Pay via Credit/Debit Card',
  SAVED_CARD: 'Pay via Saved Card',
  NEW_CARD: 'Pay with New Card',
  PAY_AT_COUNTER: 'Pay at counter',
  COD: 'COD',
};

export const PAYMENT_METHOD_ANALYTICS_VALUE = {
  CASH: 'Cash',
  CASH_LOYALTY: 'Cash Loyalty',
  CARD: 'Credit/Debit card',
  CARD_LOYALTY: 'Credit/Debit card Loyalty',
  LOYALTY: 'Loyalty',
  APPLE_PAY: 'Apple Pay',
  FREE: 'Free',
  PAY_AT_COUNTER: 'Pay at counter'
};

export const DEFAULT_SORT_BY = {
  key: 'relevance',
  displayName: 'Relevance',
};

export const WISHLIST_GA_EVENT = {
  ADD_TO_WISHLIST: 'add_to_wishlist',
  REMOVE_FROM_WISHLIST: 'remove_from_wishlist',
};

export const HOME_PAGE_JSON_FILE_NAME = {
  WEB: 'aster-epharmacy-home-page.json',
  MOBILE: 'aster-epharmacy-home-page-mobile.json',
};

export const HP_BANNER_TYPE = {
  CREATE: 'HEALTH_PROFILE_CREATE',
  PARTIAL: 'HEALTH_PROFILE_PARTIAL',
};

export const PAGE_TITLES = {
  ASTER_HOME: 'myAster Home',
  ONLINE_PHARMACY: 'Online pharmacy Home',
  CHECKOUT: 'Checkout',
  MY_CART: 'My Cart',
  RX_UPLOAD: 'Rx Upload',
  ORDER: 'Order Page',
};

export const X_PATIENT_API_VERSION = '2.2.5';
export const X_USER_AGENT = 'aster-web/2.1';

export const RX_PAYMENT_MODE = {
  SELF_PAY: { value: 'Self Pay', label: 'Self-Pay' },
  INSURANCE: { value: 'Insurance', label: 'Insurance' },
};

export const ERX_CONSTANTS = {
  PRESCRIPTION: 'Prescription',
  PROCESSING: 'Processing',
  OUT_FOR_DELIVERY: 'Out for delivery',
  SHIPMENT: 'Shipment',
};

export const BANNERS = {
  TWO_IN_ONE_BANNER: 'TWOINONE_BANNER',
  HERO_BANNER: 'Hero Banner',
  PROMOTIONAL_BANNER: 'PROMOTIONAL_BANNER',
  QUICK_BANNER: 'QUICK_BANNER',
};

export const ADJUST_EVENT_TOKENS = {
  ADDED_PAYMENT_INFO_PHARMACY: 'syhytg',
  ADD_PAYMENT_INFO: '4kx6t6',
  ADD_TO_CART_PHARMACY: '43z1uo',
  COMPLETE_REGISTRATION: 'k9mc8v',
  CONFIRM_APPOINTMENT: '4s5l8r',
  INITIATE_CHECKOUT: 'cbngkc',
  INITIATED_CHECKOUT_PHARMACY: '8c7ez8',
  PROFILE_COMPLETION: 'wv50nc',
  PURCHASE_PHARMACY: 'wkn3b7',
  VIEW_CONTENT: 'e04bnl',
  VIEWED_CONTENT_PHARMACY: '56zcrc',
  PURCHASE_CONSULT_DOCTOR: 'ktwgs3',
};

export const BOOK_APPOINTMENT_ERROR = {
  DOCTOR_HISID_CONFLICT: 'DOCTOR_HISID_CONFLICT',
  DOCTOR_HISCONNECTOR_FAILS: 'HIS_CONNECTOR_FAILS',
  DUPLICATE_INSURANCE_HIS_ID: 'DUPLICATE_INSURANCE_HIS_ID',
};

export const monthFilter = ['Last Month', 'Last 3 Months', 'Last 6 Months'];

// disabling Any Time filter for records temporarily
export const monthFilterForRecord = ['Last Month', 'Last 3 Months', 'Last 6 Months'];

export const FILTER_LEVEL_LIMIT = 6;
export const FILTER_SEARCH_LIMIT = 5;
export const PLP_PAGE_SIZE = 52;
export const EXPRESS_DEFAULT_FLAG = false;
export const HOME_CAROUSELS_ITEM_LIMIT = 10;
export const PLP_API_PARAMS_SEPARATOR = '$,';

export const staticAscoJson = 'https://asterdmstorageaccount.blob.core.windows.net/static/asco-cms.json';

export const staticAtJson = 'https://asterdmstorageaccount.blob.core.windows.net/static/at-cms.json';

export const staticAeJson = 'https://asterdmstorageaccount.blob.core.windows.net/static/ae-cms.json';

export const staticHomecareJson = 'https://asterdmstorageaccount.blob.core.windows.net/static/homecare-cms.json';

export const LOCATION_ERROR_MESSAGE =
  'Homecare services are not available in the selected location, please change location';
export const HEALTH_PACKAGES_STATUS = {
  RESERVED: 'Reserved',
  CANCELLED: 'Cancelled',
  CONFIRMED: 'Confirmed',
};

export const SLOT_STATUS = {
  NOTAVAILABLE: 'NotAvailable',
  AVAILABLE: 'Available',
};

export const NPS_EVENTS = {
  AT_VIDEO_APP_BOOKED_WEB: 'AT_VIDEO_APP_BOOKED_WEB',
  AE_ORDER_PLACED_WEB: 'AE_ORDER_PLACED_WEB',
  AHC_APP_BOOKED_WEB: 'AHC_APP_BOOKED_WEB',
  AT_VIDEO_APP_COMPLETED_WEB: 'AT_VIDEO_APP_COMPLETED_WEB',
  AE_ORDER_DELIVERED_WEB: 'AE_ORDER_DELIVERED_WEB',
};

export const APP_FULL_MONTH_DAY_YEAR_FORMAT = 'MMMM DD, YYYY';
export const APP_12_HOUR_H_FORMAT = 'h A';
export const HOME_CARE_ROUTE = '/home-care';
export const HOME_CARE_TITLE = 'Homecare';
export const HOME_CARE_SERVICES = 'services';
export const HOME_CARE_PATHS = [
  '/home-care/my-cart',
  '/home-care/my-cart/appointment',
  '/home-care/checkout',
  '/home-care/confirmation',
];

export const SERVICE_ADDED_IN_WISHLIST = 'Service added to My List';
export const PACKAGE_ADDED_IN_WISHLIST = 'Package added to My List';
export const SERVICE_REMOVED_IN_WISHLIST = 'Service has been removed from My List';
export const PACKAGE_REMOVED_IN_WISHLIST = 'Package has been removed from My List';
export const SERVICE_ADDED_IN_CART = 'Service added to Homecare Services';
export const PACKAGE_ADDED_IN_CART = 'Package added to Homecare Services';
export const SERVICE_REMOVED_FROM_CART = 'Service removed from Homecare Services';
export const PACKAGE_REMOVED_FROM_CART = 'Package removed from Homecare Services';
export const RX_PRESCRIPTION_TITLE = 'Rx Prescription Required';
export const REQUEST_CONSULTATION = 'Request consultation';
export const I_HAVE_PRESCRIPTION = 'Yes, I Have a Prescription';
export const SCHEDULED_EXPRESS_FLAG = 'ae_web_scheduled_express';
export const PRESCRIPTION_MODAL_MESSAGE =
  "Prescription is compulsory for this service. If you don't have a prescription, consult our doctor now.";
export const CONSENT_MODAL_MESSAGE =
  'This service would need below documents. Please keep them ready & submit  to healthcare provider on the appointment time.';
export const PROFILE_COMPLETE_MESSAGE = 'Your documents are submitted successfully';
export const REGISTERED_MESSAGE = 'Registered successfully';
export const ADDRESS_ADDED_MESSAGE = 'Address has been added';
export const ADDRESS_DELETED_MESSAGE = 'Address deleted successfully';
export const FILE_SIZE_ERROR_MESSAGE = 'File size limit exceeded. Maximum size (10MB)';
export const FILE_TYPE_ERROR_MESSAGE = 'File format is not supported. Please upload PNG, JPG, PDF & Docx';
export const PROCCED_ONLY_TEXT = 'Checkout only Rx items';
export const APPOINTMENT_CONFIRMED = 'Your Appointments has been confirmed';
export const APPOINTMENT_RESCHEDULED = 'Your Appointment has been rescheduled';
export const INSURANCE_ADDED_MESSAGE = 'Insurance added successfully';
export const PATIENT_REGISTERED_MESSAGE = 'Registered successfully';
export const EXPRESS_ICON_URL = 'https://asterdmstorageaccount.blob.core.windows.net/static/cardIcon/express.gif';
// export const KEYCLOAK_EMAIL_CLIENTID = 'email-native';
// export const KEYCLOAK_SMS_CLIENTID = 'sms-native';
// export const KEYCLOAK_UAEPASS_CLIENTID = 'uae-pass';
export const LOGIN_SCREEN = Object.freeze({
  Welcome: 'welcome',
  OTP: 'otp',
  Email: 'email',
  Password: 'password',
  TemporaryPassword: 'tempPassword',
  OTPLocked: 'otpLocked',
  CreatePassword: 'createPassword',
  ForgotPassword: 'forgotPassword',
  ForgotPasswordConfirmation: 'forgotPasswordConfirmation',
  Registration: 'registration',
  EmailUpdate: 'emailUpdate',
  ProfileLinking: 'profileLinking',
  ProfileLinkingLogin: 'profileLinkingLogin',
  ProfilelinkingRegistration: 'profilelinkingRegistration',
  CompleteProfile: 'completeProfile',
  ProfileLinkingBlank: 'profileLinkingBlank',
});

export const MANUAL_SYNC = {
  NOT_SYNCED: 'NOT_INITIATED',
  SYNCED: 'COMPLETED',
  SYNCING: 'IN_PROGRESS',
};

export const MANUAL_SYNC_EVENTS = {
  SYNC_CLICK: 'sync_click',
  SYNC_ERROR: 'sync_error',
  SYNC_COMPLETE: 'sync_complete',
};

export const WEBVIEW_EVENTS = {
  CALl_END: 'VIDEO_CALL_END',
  HIDE_NAVBAR: 'HIDE_NAVBAR',
  SHOW_NAVBR: 'SHOW_NAVBR',
  ADDRESS_CLOSED: 'ADDRESS_CLOSED'
};

export const DISCOUNT_BADGE = "Extra {{discount}}% OFF on online payment";

export const CART_TYPES = {
  AE: 'AE',
  RX: 'RX',
}

export const WISHLIST_TYPES = {
  AE: 'AE'
}

export const USER_TYPES = {
  PATIENT: 'Patient'
}

export const SCREEN_NAME = {
  ASCO: 'asco homepage',
  AT: 'doctor consult homepage',
  SEARCH_RESULT: 'doctor search result',
  BOOKING_CONFIRMATION: 'booking confirmation',
  APPOINTMENT_DETAIL: 'appointment detail',
  APPOINTMENT_LIST: 'appointment list',
  APPOINTMENT_CHECKOUT: 'appointment checkout',
  AE: 'epharmacy homepage',
  HC: 'homecare homepage',
  CLINIC_LIST: 'clinics listing',
  ASTER_SECURE: 'aster secure',
  ABOUT_US: 'about us',
  CONSENT_FORM: 'consent form',
  PRIVACY_POLICY: 'privacy policy',
  TERMS_CONDITIONS: 'terms and conditions',
  ADD_INSURANCE: 'add insurance',
  INSURANCE_LIST: 'insurance listing',
  MANAGE_ADDRESS: 'manage address',
  MY_PACKAGES: 'my package',
  NOTIFICATIONS: 'notifications',
  PATIENT_PORTAL: 'patient portal',
  ADD_FAMILY_MEMBER: 'add family members',
  COMPLETE_PROFILE: 'complete profile',
  EDIT_PROFILE: 'edit profile',
  MANAGE_FAMILY_MEMBER: 'manage family members',
  MY_PROFILE: 'my profile',
  COMPLETE_PROFILE: 'complete profile',
  RECORDS_DETAILS: 'records detail',
  RETURN_POLICY: 'return policy',
  DSR: 'doctor search result',
  INSTANTGP_CHECKOUT: 'instantgp checkout',
  INSTANTGP_INFORMATION: 'instantgp information',
  MANAGE_PAYMENT: 'manage payment',
  PACKAGE_DETAILS: 'package details',
  PACKAGE_ORDER_CONFIRMATION: 'package order confirmation',
  PACKAGE_CHECKOUT: 'package checkout',
  PACKAGE_LIST: 'package listing',
  PACKAGE_CLINIC_DETAIL: 'package clinics detail',
  POST_CONSULTATION: 'post consultation',
  WAITING_ROOM: 'waiting room',
  CONSULTATION_SUMMARY: 'consultation confirmation summary',
  SCHEDULED_EXPRESS: 'Scheduled',
  INSTORE_PAYMENT: 'instore_payment_option',
  MARKETING_PAGE: 'marketing page',
};

export const BUTTON_NAME = {
  AT: 'Consult a Doctor',
  AE: 'Online Pharmacy',
  HC: 'Homecare',
};

export const MEDICATION_ITEMS = {
  DOSE: 'Dose',
  FREQUENCY: 'Frequency',
  DURATION: 'Duration',
  QUANTITY: 'Quantity',
  INSTRUCTION: 'Instruction',
};

export const HomeSampleCollection = {
  HOME_SAMPLE: 'Home sample collection',
  CLINIC_NAME: 'Aster Clinic, Aswaaq Mall',
  CLINIC_ID: 'DHA-F-0001117',
};

export const FACILITYNAME = {
  HOSPITAL: 'hospital',
  CLINIC: 'clinic',
};

export const FILTER_SELECTION = {
  ENABLED: 'filter enabled',
  DISABLED: 'filter disabled',
};

export const UAE_PASS_LOGIN_TYPE = {
  BOOKING: 'booking',
  NORMAL: 'normal',
};

export const PROFILE_MISMATCH_ERROR_CODE = "PM00001";
export const ACCOUNT_EXIST_ERROR_CODE = "PM00002";

export const REGISTRATION_FORM_ERRORS = {
  SELECT_GENDER: "Please select gender",
  LESS_THAN_EIGHTEEN: 'Age must be over 18 years',
  ENTER_DOB: 'Please enter date of birth',
  VALID_DOB: 'Please enter valid date of birth',
  SELECT_NATIONALITY: 'Please select nationality',
};

export const COMPLETE_PROFILE_UAE_PASS_ERRORS = {
  EMIRATESID : 'emiratesID',
  PASSPORT_NUM_LABEL : 'passportNum',
  PASSPORT_NUM_ERROR  : 'Please enter passport number',
  ID_ERROR1 : 'Please enter emirates Id',
  ID_ERROR2 : 'First three digits should be 784',
  ID_ERROR3 : 'Invalid EID number',
  ID_ERROR4 : 'Age must be over 18 years',
  ID_ERROR5 : 'Please enter complete emirates Id ',
  MISMATCH_YOB: 'Mismatch found in Year of Birth',
};

export const getScreenName = (screenName, categoryName, headerPackageName, facilityName) => {
  let screen = '';
  if (screenName === 'Aster Core Home') {
    screen = PAGE_NAME?.HOME;
  } else if (screenName === 'Tele Consult Home') {
    screen = PAGE_NAME?.TC_HOME;
  } else if (screenName === 'doctor search result') {
    screen = SCREEN_NAME?.SEARCH_RESULT;
  } else if (screenName === 'bookingConfirmation') {
    screen = SCREEN_NAME?.BOOKING_CONFIRMATION;
  } else if (screenName === 'appointmentdetails') {
    screen = PAGE_NAME?.ADP;
  } else if (screenName === 'package List') {
    if (categoryName !== 'undefined' && categoryName !== undefined) {
      screen = `${categoryName} packages`;
    } else {
      screen = 'package listing';
    }
  } else if (screenName === 'packagedetails') {
    screen = headerPackageName || '';
  } else if (screenName === 'facility') {
    screen = facilityName || '';
  } else {
    screen = screenName;
  }
  return screen?.toLowerCase();
};

export const getPageType = (pageName, screenName, categoryName) => {
  let pageType = '';
  if (pageName === 'Aster Core Home' || pageName === 'Tele Consult Home') {
    pageType = PAGE_TYPE?.HOME;
  } else if (pageName === 'search results page') {
    pageType = PAGE_NAME?.SRP;
  } else if (pageName === 'bookingConfirmation') {
    pageType = SCREEN_NAME?.APPOINTMENT_DETAIL;
  } else if (pageName === 'appointmentdetails') {
    pageType = PAGE_NAME?.AP;
  } else if (screenName === 'package List') {
    if (categoryName !== 'undefined' && categoryName !== undefined) {
      pageType = 'package categories listing';
    } else {
      pageType = PAGE_NAME?.PACKAGE;
    }
  } else if (pageName === 'packagedetails') {
    pageType = PAGE_NAME?.PDP;
  } else if (pageName === 'facility details page') {
    pageType = PAGE_NAME?.FDP;
  }
  return pageType?.toLowerCase();
};

export const HISSYSTEM = {
  LT: 'LT',
  AKHIL: 'Akhil',
};

export const COUPON_TYPE = {
  REGULAR: 'regular',
  REFERRAL: 'referral'
};

export const COUPON_APPLY_TYPE = {
  MANUAL: 'manual',
  AUTO: 'auto applied',
  LIST: 'coupon list popup',
  CARD: 'coupon card'
};

export const FLAGSMITH_KEYS = {
  PROMOTION_LEAFTLET_FLAGSMITH: 'ae_web_promotion_leaflet',
  FLASH_DELIVERY: 'ae_web_flash_delivery',
  CART_AND_CHECKOUT: 'ae_web_cart_and_checkout',
  POM_PRODUCT_FLAG: 'ae_web_pom',
  REFERRAL_COUPON: 'ae_web_referral_coupon',
  MERGE_SHIPMENT: 'ae_web_mergeshipment',
  REFERRAL_COUPON: 'ae_web_referral_coupon',
  COMMON_API_ACTION: 'ae_common_api_actions',
  WEB_FEATURE_FLAGING: 'web_feature_flaging',
  WEB_COMMON: 'web_common',
};

export const PAGE_NAMES = {
  CHECKOUT: '/checkout',
  SP_CHECKOUT: '/spcheckout'
}

export const DELIVERY_TYPES = {
  RX: 'RX',
  FLASH: 'FLASH',
  EXPRESS: 'EXPRESS',
  STANDARD: 'STANDARD',
  OOS: 'OOS'
};

export const PAGE_TYPES = {
  CART: 'cart',
  CHECKOUT: 'checkout'
}

export const DELIVERY_CHARGES = {
  FLASH: 'Flash Delivery Charge',
  EXPRESS: 'Express Delivery Charge',
  STANDARD: 'Standard Delivery Charge',
  RX: 'Rx Delivery Charge'
};

export const DELIVERY_CHARGES_KEYS = {
  FLASH: 'flashDeliveryCharge',
  EXPRESS: 'expressDeliveryCharge',
  STANDARD: 'standardDeliveryCharge',
  SERVICE_FEE: 'serviceFee',
  POM: 'rxDeliveryCharge',
  COD_FEE: 'codFee'
};

export const DELIVERY_METHOD = {
  FLASH: 'Flash',
  EXPRESS: 'Express',
  STANDARD: 'Standard',
  SCHEDULE: 'Scheduled',
};

export const DELIVERY_CART_TITLE = {
  POM: 'Prescription Medicines',
};

export const POM_CONSTANTS = {
  TITLE: 'Upload respective prescriptions to continue',
  SUB_TITLE: 'Upload prescription',
  DISCLAIMER: 'PNG, JPG & JPEG, PDF (File Size: upto 10MB)'
};

export const FACET_KEYS = {
  IS_FLASH: 'isFlash',
  EXPRESS: 'express_bool'
};

export const RELATIVE_DATES = {
  TODAY: 'Today',
  TOMORROW: 'Tomorrow'
};

export const AE_GLOBAL = {
  SHIPMENT: 'Shipment',
  SERVICE_FEE: 'Service Fee',
  RX: 'RX',
  FLASH: 'flash',
  POM: 'pom',
  EXPRESS: 'express',
  STANDARD: 'standard',
  MIXED: 'mixed',
  SCHEDULED: 'scheduled',
  POM: 'pom',
  USER_ZONE: 'userZone',
  INS_ZONE: 'ins_zone',
  DELIVERY_BY: 'Delivery by',
  BUY_AGAIN: 'Buy Again',
  DELIVER_IN: 'Deliver in',
  CART_FILLERS: 'Cart Fillers',
};

export const LOCALSTORAGE_KEYS = {
  INSTORE: 'instore',
  ORDER_SUMMARY: 'OrderSummary',
  LONGITUDE: 'Longitude',
  LATITUDE: 'Latitude',
  DEFAULT_LOCATION: 'defaultLocation',
  PERSIST_ADD_CHANGE: 'persist_addressChange',
  ADDRESS_ID: 'addressId',
  GUEST_USER_ADDRESS: 'guestUserAddress',
  GUEST_MOBILE: 'guestMobile',
  GUEST_REGISTRATION: 'guestRegistration',
  GUEST_USER_ID: 'guestUserId',
  GUEST_COUPON: 'guestCoupon',
  GUEST_MOBILE_DATA: 'guestMobileData',
  APPLIED_COUPON: 'appliedCoupon',
  CART_ICON_ANIMATION: 'cartIconAnimation',
  REFERRAL_CODE: 'referralCode',
  IS_MERGE_CART_CALLED: 'isMergeCartCalled',
  PRESCRIPTION_UPLOADED_FILES: 'uploadedFiles',
  PRESCRIPTION_RX_ID: 'prescriptionerxId',
  OLD_CART_ID: 'oldCartId',
  COUPON_APPLIED_CART: 'couponAppliedCart',
  ERX_CART_ID: 'erxCartId',
  PREFERRED_ADDRESS: 'preferredAddress',
  AUTOSELECT_ADDRESS: 'autoSelectAddress',
  IS_GUEST: 'isGuest',
  PREFERRED_ADDRESS: 'preferredAddress'
};

export const SESSION_STORAGE_KEYS = {
  OLD_CART_ID: 'oldCartId',
  IS_MERGE_CART_CALLED: 'isMergeCartCalled',
}

export const getFacilityId = (facilityId, homeSample) => {
  if (homeSample) {
    return 'DHA-F-0001117';
  } else {
    return facilityId;
  }
};

export const getfacilityName = (facilityName, homeSample) => {
  if (homeSample) {
    return 'Aster Clinic, Aswaaq Mall';
  } else {
    return facilityName;
  }
};

export const getPaymentType = (paymentType) => {
  if (paymentType === 'Pay with New Card') {
    return 'Pay Via Credit/Debit Card';
  } else {
    return paymentType;
  }
};

export const DYNAMIC_DASHBOARD_COMPONENT_TYPES = {
  Hero_Banner: "Hero Banner",
  Hero_Promo_Banner: "Hero Promo Banner",
  Business_Unit_Block: "Business Unit Block",
  Referral: "Referral",
  Welcome_Offer: "Welcome Offer",
  Promotional_Offer: "Promotional Offer",
  Instant_Booking_Banner: "Instant Booking Banner",
  Two_in_One_Banner: "Two in One Banner",
  four_in_one_Banner: "four-in-one Banner",
  five_in_one_Banner: "five-in-one Banner",
  six_in_one_Banner: "six-in-one Banner",
  eight_in_one_Banner: "eight-in-one Banner",
  category_carousel: "category-carousel",
  My_Doctors: "My Doctors",
  Blog: "Blog",
  New_Doctors: "New Doctors",
  Product_Carousel: "Product Carousel",
  Saved_Products: "Saved Products",
  Promotional_Banner: "Promotional Banner",
  Brand_Carousel: "Brand Carousel",
  Upload_Prescription: "Upload Prescription",
  Quick_Banner: "Quick Banner",
  Facilities_near_you: "Facilities near you",
  HTML_Block: "HTML Block",
  Custom_Block: "Custom Block",
  Quick_Links: "Quick Links",
  Info_Cards: "Info Card",
}

export const DYNAMIC_DASHBOARD_CAROUSEL_TYPES = {
  Homecare_Services: "Homecare Services",
  Homecare_Packages: "Homecare Packages",
  Clinic_Packages: "Clinic Packages",
}

export const ORDER_STATUSES = {
  SCHEDULED: "Scheduled",
  PROCESSING: "Processing",
  DELIVERED: 'Delivered',
  OUT_FOR_DELIVERY: 'Out For Delivery',
  CANCELLED: 'Cancelled',
  RETURNED: 'Returned'
}

export const ORDER_PACKAGE_STATUSES = {
  CANCELLED: 'Cancelled',
}

export const CLICKEDMENU = {
  NOTIFICATION: 'notification',
  SECURE: 'secure',
};

export const getScreenNameForMenuclick = (text) => {
  let screenName;
  if (text === 'Family Members') {
    screenName = 'manage family members';
  } else if (text === 'My Packages') {
    screenName = 'my packages listing';
  } else if (text === 'Lists') {
    screenName = 'wishlist all';
  } else if (text === 'Records') {
    screenName = 'records prescription';
  } else if (text === 'Cancellation, Return & Refund Policy') {
    screenName = 'return policy';
  } else if (text === 'Settings') {
    screenName = 'main settings';
  } else {
    screenName = text?.toLowerCase();
  }
  return screenName;
};

export const getPageTypeForMenuclick = (text) => {
  let pagetype;
  if (text === 'Appointments') {
    pagetype = 'appointments page';
  } else if (text === 'My Packages') {
    pagetype = 'package page';
  } else if (text === 'Lists') {
    pagetype = 'wishlist page';
  } else if (text === 'Records') {
    pagetype = 'records page';
  } else if (text === 'My Orders') {
    pagetype = 'order listing page';
  } else if (text === 'Cancellation, Return & Refund Policy') {
    pagetype = 'content page';
  } else {
    pagetype = 'profile page';
  }
  return pagetype;
};

export const getScreenNameForFamilyMembers = (pathname, screen)=>{
  if (pathname?.includes('doctor-consultation') && pathname?.includes('appointments')) {
    return 'appointments listing';
  } else if (pathname?.includes('records') && pathname?.includes('doctor-consultation')) {
    if (screen === 'prescription') {
      return 'records prescription';
    } else if (screen === 'lab') {
      return 'records lab';
    } else if (screen === 'scan') {
      return 'records scan';
    } else if (screen === 'all') {
      return 'records all';
    }
  } else{
    return 'add family members'
  }
};

export const getPageTypeForFamilyMembers = (pathname) => {
  if (pathname?.includes('doctor-consultation') && pathname?.includes('appointments')) {
    return PAGE_NAME?.AP;
  } else if (pathname?.includes('records') && pathname?.includes('doctor-consultation')) {
    return PAGE_TYPE?.RECORDS_PAGE;
  } else{
    return PAGE_TYPE?.PROFILE;
  }
};

export const getReferrerPageForFamilyMembers = (pathname) => {
  if (pathname?.includes('doctor-consultation') && pathname?.includes('appointments')) {
    return PAGE_NAME?.ALP;
  } else if (pathname?.includes('records') && pathname?.includes('doctor-consultation')) {
    return PAGE_NAME?.RLP;
  } else{
    return 'add family members page';
  }
};

export const getScreenNameForAddFamily = (pathname) => {
  if (pathname?.includes('doctor-consultation') && pathname?.includes('checkout')) {
    return SCREEN_NAME?.PACKAGE_CHECKOUT;
  } else if (pathname?.includes('doctor-consultation') && pathname?.includes('clinicdetails')) {
    return SCREEN_NAME?.PACKAGE_CLINIC_DETAIL;
  } else if (pathname?.includes('profile')) {
    return SCREEN_NAME?.ADD_FAMILY_MEMBER;
  } else {
    return SCREEN_NAME?.ASCO;
  }
};

export const getPageTypeForAddFamily = (pathname) => {
  if (pathname?.includes('doctor-consultation') && pathname?.includes('checkout')) {
    return PAGE_NAME?.PACKAGE;
  } else if (pathname?.includes('doctor-consultation') && pathname?.includes('clinicdetails')) {
    return PAGE_NAME?.PACKAGE;
  } else if (pathname?.includes('doctor-consultation') && pathname?.includes('d')) {
    return PAGE_NAME?.DDP;
  } else if (pathname?.includes('profile')) {
    return PAGE_TYPE?.PROFILE;
  } else {
    return PAGE_TYPE?.HOME;
  }
};

export const PAYMENT_METHOD_CODES = {
  counter: "COUNTER"
}

export const BUISNESS_UNIT_CODE = {
  EPHARMACY_STORE: 'EPHARMACY-STORE',
  EPHARMACY: 'EPHARMACY'
};

export const IMAGE_SHAPE = {
  RECTANGLE: 'rectangle',
  CIRCLE: 'circle',
};

export const GET_HOST_COUNTRY = {
  UAE: 'United Arab Emirates',
};

export const KSA_FLAGSMITH_KEYS = {
  MORE_MENU: {
    AT_MODULE_SWITCHER: 'AT_MODULE_SWITCHER',
    AE_MODULE_SWITCHER: 'AE_MODULE_SWITCHER',
    HOME_CARE_MODULE_SWITCHER: 'HOME_CARE_MODULE_SWITCHER',
    RX_UPLOAD_PRESCRIPTION: 'RX_UPLOAD_PRESCRIPTION',
    MEGAMENU_DEALS: 'MEGAMENU_DEALS',
    MEGAMENU_EXPRESS: 'MEGAMENU_EXPRESS',
  },
  FOOTER_SECTION: {
    FOLLOW_US: 'FOLLOW_US',
    AVAILABLE_PAYMENT_OPTIONS: 'AVAILABLE_PAYMENT_OPTIONS',
  }
};

export const COUNTRY_LIST = [
  { regionName: 'uae-en', region: 'UAE', language: 'English', flagImage: IC_FLAG_971, regionCode: 'AE', langCode: 'en', timezone: 'Asia/Dubai' },
  { regionName: 'sa-en', region: 'Saudi Arabia', language: 'English', flagImage: IC_FLAG_966, regionCode: 'SA', langCode: 'en', timezone: 'Asia/Riyadh' },
  { regionName: 'sa-ar', region: 'المملكة العربية السعودية', language: 'عربي', flagImage: IC_FLAG_966, regionCode: 'SA', langCode: 'ar', timezone: 'Asia/Riyadh' },
];

export const countryCodeDefaultKSA = [
  {
    "countryName": "Saudi Arabia",
    "countryCode": "+966",
    "flagPath": "/static/country_flags/png/Saudi_Arabia.png",
    "show": true,
    "numberLength": 9,
    "shortForm": "sa"
  },
];

export const supportedlanguages = {
  AR: 'ar',
  EN: 'en'
}

export const KSA_ALLOWED_URLS = new Set([
  '/online-pharmacy',
  '/online-pharmacy/categorylisting',
  '/online-pharmacy/brandlisting',
  '/online-pharmacy/searchresult',
  '/online-pharmacy/p/',
  '/online-pharmacy/c/',
  '/online-pharmacy/brand/',
  '/faq/payment',
  '/faq/returns&refunds',
  '/content/aboutus',
  '/content/termsandcondition',
  '/content/privacypolicy',
]);

export const REGION_SWITCHER_DISALLOWED_URLS = [
  '/online-pharmacy/mycart',
  '/online-pharmacy/spcheckout',
  '/online-pharmacy/checkout',
  '/home-care',
  '/doctor-consultation',
];

export const getErrorType = (errorCode) => {
  const errorTypeMap = {
    400: 'validation',
    404: 'validation',
    417: 'validation',
    500: 'api',
    502: 'api',
    503: 'api',
    NETWORK_ERROR: 'network',
    timeout: 'timeout',
  };

  return errorTypeMap[errorCode] || 'javascript';
};

export const VALID_REGION_LANGS = COUNTRY_LIST.map(country => country.regionName);
// eslint-disable-next-line no-nested-ternary
export const DEFAULT_REGION_LANG = HOST_COUNTRY
  ? `${HOST_COUNTRY}-en`
  : process.env.NEXT_PUBLIC_SENTRY_ENV === 'PROD-F' || process.env.NEXT_PUBLIC_SENTRY_ENV === 'PREPROD-F'
  ? 'uae-en'
  : 'sa-en';

export const RE_DIRECTION_CODE = 301;

export const detectNormalBrowser = (userAgent) => {
  if (!userAgent) return false;
  // List of known normal browsers
  const normalBrowserPattern = /(Chrome|Chromium|Firefox|Safari|Edge|Opera)/i;
  // If it matches a known normal browser, return true
  return normalBrowserPattern.test(userAgent);
};

export const adjustLinks = {
  verifyHome: 'https://myaster.go.link/gFe5R',
  verifyProfile: 'https://myaster.go.link/bRlkX'
}